export const URLS = {
  PRE_CHAT: '/pre-chat',
  CHAT: '/chat',
  CHAT_ERROR: '/chat/error',
  AGENT_ERROR: '/agent/error',
  CART: '/cart',
  DETAILS: '/details',
  ADDRESS: '/address',
  PAYMENT: '/payment',
  REVIEW: '/review',
  COMPLETE: '/order-complete',
  WELCOME: '/',
  ENDPOINT: {
    MEDIATOR_CLIENT_SUBSCRIBE: '',
  },
}

export const MODAL_LOCATION = {
  CHAT: 'chat',
  PRE_CHAT: 'pre-chat',
  CART: 'cart',
}

export const PAYMENT_STATUS = {
  ACCEPTED: 'A',
  DECLINED: 'D',
}
export const ID = {
  COVET_CHAT_APP_ELEMENT: '#covert-chat-app',
}

export const LANGUAGES = {
  en: { label: 'English', locale: 'en', code: 'en-CA' },
  fr: { label: 'Franҫais', locale: 'fr', code: 'fr-CA' },
}

export const HELP = {
  en: { val: 'help' },
  fr: { val: 'aide' },
}

export const DEFAULT_LOCALE = LANGUAGES.en.locale

export const PAYMENT_CARD = {
  visa: {
    label: 'visa',
  },
  mastercard: {
    label: 'mastercard',
  },
  amex: {
    label: 'amex',
  },
}

export const COLORS = {
  linkBlue: '#085EB9',
}
export const CSS_PROPS = {
  fontFamily: {
    icons: 'bbyc-crm-covert-app-icon-fonts',
    openSans: '"Open Sans", sans-serif',
  },
}

export const WS_CONNECT = 'WS_CONNECT'
export const WS_CONNECTED = 'WS_CONNECTED'
export const WS_DISCONNECT = 'WS_DISCONNECT'
export const WS_DISCONNECTED = 'WS_DISCONNECTED'
export const WS_REQUEST = 'WS_REQUEST'
export const WS_NOTIFY = 'WS_NOTIFY'
export const APP_SHOW_ERROR = 'APP_SHOW_ERROR'
export const APP_CLEAR_ERROR = 'APP_CLEAR_ERROR'

/* Environment variables used in request.js */
export const LOCALHOST = 'localhost:3000'
export const SERVICE_HOST_ENV_VAR = 'SERVICE_HOST_ENV_VAR'
export const CYBER_SOURCE_HOST_ENV_VAR = 'CYBER_SOURCE_HOST_ENV_VAR'
export const CANADA_POST_ADDRESS_COMPLETE = 'CANADA_POST_ADDRESS_COMPLETE'
export const CANADA_POST_RETRIEVE_ADDRESS = 'CANADA_POST_RETRIEVE_ADDRESS'
export const CANADA_POST_API_KEY = 'CANADA_POST_API_KEY'
export const ENABLE_AUTO_COMPLETE = 'ENABLE_AUTO_COMPLETE'
export const BUSINESS_SUPPORT = 'BUSINESS_SUPPORT'
export const ASSURANT_CHAT = 'ASSURANT_CHAT'
export const UPDATE_ROUTE = 'UPDATE_ROUTE'
export const CODE = 'CODE'
export const GSPP = 'Geek Squad Protection Purchase'
export const GSTS = 'Geek Squad Technical Support'
export const BBPI = 'Best Buy Product Inquiry'
export const BBOI = 'Best Buy Order Inquiry'
export const GSFSS = 'Geek Squad In-Home Scheduling'
export const GSFSS_CHAT = 'GSFSS CHAT'
export * from './App/constants'
export * from './Cart/constants'




// WEBPACK FOOTER //
// ./src/containers/constants.js